<template>
  <div>未找到该页面</div>
</template>

<script>

  export default {
    name: '404',
    components: {},
    data() {
      return {

      }
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    computed: {

    },
    methods: {

    }
  }
</script>


<style scoped lang="scss">

</style>
